module.exports = __webpack_public_path__ + "static/sectorwatch-f54ec58a2878900d7912c283b1ef49d9.png";